export default "/_next/static/media/Turkish Dried Fruits.02b9a2a199cf158481057e5dd933b745.jpeg";